import { storableError } from '../../util/errors';
import { fetchSeoCitySubpage } from '../../util/seoDiscoveryFetch';

export const FETCH_CITY_SUBPAGE_REQUEST = 'app/SeoDiscoveryCitySubpage/FETCH_REQUEST';
export const FETCH_CITY_SUBPAGE_SUCCESS = 'app/SeoDiscoveryCitySubpage/FETCH_SUCCESS';
export const FETCH_CITY_SUBPAGE_ERROR = 'app/SeoDiscoveryCitySubpage/FETCH_ERROR';

const initialState = {
  payload: null,
  fetchInProgress: false,
  fetchError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_CITY_SUBPAGE_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_CITY_SUBPAGE_SUCCESS:
      return { ...state, fetchInProgress: false, payload };
    case FETCH_CITY_SUBPAGE_ERROR:
      return { ...state, fetchInProgress: false, fetchError: payload };
    default:
      return state;
  }
}

const fetchRequest = () => ({ type: FETCH_CITY_SUBPAGE_REQUEST });
const fetchSuccess = payload => ({ type: FETCH_CITY_SUBPAGE_SUCCESS, payload });
const fetchError = e => ({ type: FETCH_CITY_SUBPAGE_ERROR, payload: storableError(e) });

export const loadData = (params, search, config) => dispatch => {
  const { citySlug, subpageSlug } = params || {};
  if (!citySlug || !subpageSlug) {
    return Promise.resolve();
  }
  dispatch(fetchRequest());
  return fetchSeoCitySubpage(citySlug, subpageSlug)
    .then(data => dispatch(fetchSuccess(data)))
    .catch(e => {
      dispatch(fetchError(e));
      throw e;
    });
};
